import { render, staticRenderFns } from "./listProp.vue?vue&type=template&id=209520e8&scoped=true&"
import script from "./listProp.vue?vue&type=script&lang=js&"
export * from "./listProp.vue?vue&type=script&lang=js&"
import style0 from "./listProp.vue?vue&type=style&index=0&id=209520e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209520e8",
  null
  
)

export default component.exports